package pt.at.oss.kotlin.manual.storage.unionForm

import kotlinx.serialization.Serializable
import pt.at.oss.kotlin.manual.storage.common.Address
import pt.at.oss.kotlin.manual.storage.common.VatId
import pt.at.oss.kotlin.manual.storage.common.bankaccountinfo.BankAccountInfo
import pt.at.oss.kotlin.manual.storage.common.contactinfo.ContactInfo
import pt.at.oss.kotlin.manual.storage.common.contactname.ContactName
import pt.at.oss.kotlin.manual.storage.common.currvatid.CurrVatId
import pt.at.oss.kotlin.manual.storage.common.fixedestablishments.FixedEstablishmentsEntry
import pt.at.oss.kotlin.manual.storage.common.relevantdates.RelevantDates
import pt.at.oss.kotlin.manual.storage.common.supplycommencement.SupplyCommencement
import pt.at.oss.kotlin.manual.storage.common.tradingnames.TradingNamesEntry
import pt.at.oss.kotlin.manual.storage.common.websites.WebsitesEntry
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * UnionForm Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class UnionForm(
    var currVatId: CurrVatId? = CurrVatId(),
    var actsAsVatGroup: Boolean = false,
    var actsAsElectronicInterface: Boolean = false,
    var notEstablishedInEU: Boolean = false,
    var bankAccountInfo: BankAccountInfo = BankAccountInfo(),
    var fixedEstablishments: MutableList<FixedEstablishmentsEntry> = mutableListOf(),
    var idsInOtherMSs: MutableList<VatId> = mutableListOf(),
    var companyName: String = "",
    var tradingNames: MutableList<TradingNamesEntry> = mutableListOf(),
    var countryOfBusiness: String? = null,
    var cobRegion: String? = null,
    var address: Address = Address(),
    var websites: MutableList<WebsitesEntry> = mutableListOf(),
    var contactName: ContactName = ContactName(),
    var contactInfo: ContactInfo = ContactInfo(),
    var prevOrCurrOssVatId: MutableList<VatId> = mutableListOf(),
    var supplyCommencement: SupplyCommencement = SupplyCommencement(),
    var relevantDates: RelevantDates? = RelevantDates()
) : BaseRecord()
